import socketIOClient from "socket.io-client";

const ENDPOINT = process.env.REACT_APP_PUBLIC_URL.toString().substring(0, process.env.REACT_APP_PUBLIC_URL.toString().length - 1);
const socket = socketIOClient(ENDPOINT, {
    autoConnect: false
});

class NotificationsSockets {
    async sendNotification(notificacion) {
        return new Promise(function (resolve, reject) {
            socket.open();
            socket.emit('sendNotification', notificacion, function () {
                socket.close();
                resolve();
            });
        });
    }
}

export default new NotificationsSockets();
